import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronDownIcon } from "lucide-react";
import { faqs } from "../data/content";
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-white px-4 py-16" aria-labelledby="faq-title" data-id="element-79" data-mp="1l9o6f7npxxl7">
      <div className="mx-auto max-w-4xl" data-id="element-80" data-mp="1ge0ewllrkscj">
        <h2 id="faq-title" className="text-center font-heading text-2xl font-bold uppercase md:text-3xl" data-id="element-81" data-mp="2e0fypu1ny239">Frequently asked questions</h2>
        <div className="mt-8 divide-y divide-brand/20 rounded-lg border border-brand/20 bg-white" data-id="element-82" data-mp="2913dfdqfx32s">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} data-id="element-83" data-mp="1z3yml0lngjfn" data-mpi={i}>
                <button onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left font-heading text-sm font-semibold uppercase" data-id="element-84" data-mp="1z2niezoal9o0">
                  {f.q}
                  <ChevronDownIcon className={`h-4 w-4 shrink-0 text-brand transition-transform duration-200 ease-out ${isOpen ? "rotate-180" : ""}`} aria-hidden="true" data-id="element-85" data-mp="pippi9rxwxa5" />
                </button>
                <AnimatePresence initial={false} data-id="element-86" data-mp="fjibdkddsylz">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: "auto",
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-87" data-mp="khjvm8mjn3z1">
                      <div className="space-y-2 px-5 pb-5 text-sm leading-relaxed text-ink-muted" data-id="element-88" data-mp="1rtyvfz8084h">
                        {f.a.map(p => <p key={p} data-id="element-89" data-mp="3jyi1mz6ssj6z">{p}</p>)}
                        {f.list && <ul className="list-disc space-y-1 pl-5" data-id="element-90" data-mp="3nys6g8iut3k9">
                            {f.list.map(l => <li key={l} data-id="element-91" data-mp="1uinx7mq6tg3u">{l}</li>)}
                          </ul>}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}